/* istanbul ignore file */
import { NextPage } from 'next';

import config from 'config';
import ErrorBoundary from '../components/ErrorBoundary';
import ErrorPage from '../containers/ErrorPage';
import StaticPage from '../containers/StaticPage';
import { getOrCreateStore } from '../stores';

const SlugPage: NextPage = (props: any) => {
  const {
    page: { payloadStatus },
  } = props;

  const pageContent = () => {
    if (payloadStatus !== 200) {
      return <ErrorPage statusCode={payloadStatus} />;
    }
    return <StaticPage {...props} />;
  };

  return (
    <ErrorBoundary error={payloadStatus === 500} errorBoundaryId="slug-page">
      {pageContent()}
    </ErrorBoundary>
  );
};

SlugPage.getInitialProps = async (ctx) => {
  const store = getOrCreateStore();
  const isServer = !!ctx.req;
  const { slug } = ctx.query;

  const url = `${config.servicesURL}/travel/pages?slug=${slug}`;
  const result = await fetch(url);
  const res = await result.json();
  const data = res?.data || {};
  const statusCode = res?.status?.statusCode || 404;

  const pageData = data?.items?.length ? data.items[0] : null;
  const links = pageData?.block?.links;
  const block = links?.entries?.block;
  const tableData = block?.[0]?.tableData;

  if (isServer) {
    return {
      ssrReduxState: store.getState(),
      page: {
        ...data,
        payloadStatus: pageData ? statusCode : 404,
      },
      tableData: tableData?.tableData || [],
    };
  }

  return {
    page: {
      ...data,
      payloadStatus: pageData ? statusCode : 404,
    },
    tableData: tableData?.tableData || [],
  };
};

export default SlugPage;
